jQuery(document).ready(function($){
	// Nav scroll classes
	var win = $(window);
	win.scroll(function () {
		if (win.scrollTop() == 0) {
			$('#top-bar-menu').removeClass('stuck');
			$('header.header').removeClass('stuck');
			$('body').removeClass('scrolled');
		} else if (win.scrollTop() > 0) {
			$('#top-bar-menu').addClass('stuck');
			$('header.header').addClass('stuck');
			$('body').addClass('scrolled');
		}
		$('.pan').each(function() {
			if (isScrolledIntoView($(this))) {
				$(this).addClass("animate");
			}
		});
	});

	function isScrolledIntoView(elem) {
		var docViewTop = $(window).scrollTop();
		var docViewBottom = docViewTop + $(window).height();

		var elemTop = $(elem).offset().top;
		var elemBottom = elemTop + $(elem).height();
		return ((elemTop <= docViewBottom));
	}

	// Drop cap markup
	$.fn.wrapStart = function (numWords) { 
		var node = this.contents().filter(function () { 
				return this.nodeType == 3 
			}).first(),
			text = node.text(),
			first = text.split(" ", numWords).join(" ");

		if (!node.length)
			return;

		node[0].nodeValue = text.slice(first.length);
		var letters = first.split('');
		var firstLetter = '<span class="dropcap">' + letters[0] + '</span>';
		letters.shift();
		var firstWord = '<span aria-hidden="true">' + firstLetter + letters.join('') + '</span>';
		node.before(firstWord + '<span class="sr-only">' + first + '</span>');
	};
	$(".has-dropcap").each(function() {
		$(this).wrapStart(1);
	})

	$('.category-posts').each(function(num, elem) {
		elem = $(elem);
		var settings = {
			infinite: true,
			slide: '.post-slide',
			arrows: true,
			slidesToShow: 3,
			slidesToScroll: 3,
			prevArrow: $('#prev-arrow_'+num),
			nextArrow: $('#next-arrow_'+num),
			responsive: [
				{
					breakpoint: 640,
					settings: "unslick"
				}
			]
		}
		elem.slick(settings);
		$(window).on('resize', function() {
			/* If we are below mobile breakpoint unslick the slider */
			if ($(window).width() < 640)
			{
				/* Do nothing (responsive Slick's setting will unslick the slider) */
				return;
			}
			/* We are above mobile breakpoint, initialize the slider if it is not already initialized */
			if (!elem.hasClass('slick-initialized'))
			{
				return elem.slick(settings);
			}
		});
	});

	$('.publication-posts').each(function(num, elem) {
		elem = $(elem);
		var settings = {
			infinite: true,
			slide: '.post-slide',
			arrows: true,
			slidesToShow: 3,
			slidesToScroll: 3,
			prevArrow: $('#prev-arrow_1'),
			nextArrow: $('#next-arrow_1'),
			responsive: [
				{
					breakpoint: 640,
					settings: "unslick"
				}
			]
		}
		elem.slick(settings);
		$(window).on('resize', function() {
			/* If we are below mobile breakpoint unslick the slider */
			if ($(window).width() < 640)
			{
				/* Do nothing (responsive Slick's setting will unslick the slider) */
				return;
			}
			/* We are above mobile breakpoint, initialize the slider if it is not already initialized */
			if (!elem.hasClass('slick-initialized'))
			{
				return elem.slick(settings);
			}
		});
	});

	$(document).on( 'click', '#search-toggle', function() {
		$(this).toggleClass('active');
		$('#search-bar').slideToggle();
	});
});